import React, {MouseEventHandler} from 'react';

const ElevatedButton = (
  {
    className,
    width,
    onClick,
    children,
    bgColor,
    transition,
    duration,
    hover,
    focus,
    leading,
    textColor,
    textSize,
    fontWeight,
    padding,
    margin,
    rounded
  }: {
    className?: string;
    children: React.ReactNode,
    onClick: MouseEventHandler<HTMLButtonElement>,
    width?: string;
    bgColor?: string,
    transition?: string,
    duration?: number,
    hover?: string,
    focus?: string,
    leading?: string,
    textColor?: string,
    textSize?: string,
    fontWeight?: string,
    padding?: string,
    margin?: string,
    rounded?: string,
  }) => {

  bgColor ??= 'bg-gray-950 dark:bg-gray-50';
  transition ??= 'transition-all';
  duration ??= 300;
  hover ??= 'hover:bg-gray-700 dark:hover:bg-gray-300';
  focus ??= '';
  textColor ??= 'text-white dark:text-black';
  textSize ??= 'text-sm';
  fontWeight ??= 'font-semibold';
  leading ??= 'leading-6';
  padding ??= 'py-1.5 px-4';
  margin ??= '';
  rounded ??= 'rounded-lg'

  return (
    <button
      type="submit"
      onClick={onClick}
      className={`${width ?? 'w-full'} ${className} ${transition} duration-${duration} ${bgColor} ${textColor} ${hover} ${focus} ${textSize} ${fontWeight} ${leading} ${padding} ${rounded} ${margin}`}
    >
      {children}
    </button>
  );
};

export default ElevatedButton;
